import React, { Fragment } from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';
import { isEmpty, times } from 'lodash-es';

import EmptyBox from './EmptyBox';
import TotalCount from './TotalCount';
import Button from '../../../Buttons/Button';
import Skeleton from '../../../Skeleton';
import ErrorStateWithReload from '../../../ErrorStateWithReload';
import { permissionsSelector } from '../../selectors';

const publisherLinks = [
  { field: 'website', icon: 'hicon-globe-2' },
  { field: 'facebook_url', icon: 'hicon-facebook-2' },
  { field: 'twitter_url', icon: 'hicon-twitter-2' },
  { field: 'linkedin_url', icon: 'hicon-linkedin-2' },
  { field: 'crunchbase_url', icon: 'hicon-crunchbase' },
];

const PubCategories = ({ publisher, settings }) => {
  const permissions = useSelector(permissionsSelector);

  if (settings.error) return <ErrorStateWithReload />;

  const showCategories = !isEmpty(publisher.categories);

  const renderPermittedField = (content, permissionName = 'allowContactInfo') => (
    permissions[permissionName] ? content : <div className="label-md text-black">Access restricted</div>);

  return (
    <div className="prospects-sidebar__categories prospects-sidebar__box">
      <div className="prospects-sidebar__categories-info">
        <div className="prospects-sidebar__categories-head h4">
          Firmographics
        </div>
        <div className="prospects-sidebar__categories-box">
          <div className="prospects-sidebar__categories-subhead">
            Headquarters
          </div>
          <div className="prospects-sidebar__categories-info-item">
            {renderPermittedField(settings.pending ? <Skeleton height={24} /> : (publisher.headquarters || 'Not Identified'))}
          </div>
          <div className="prospects-sidebar__categories-subhead">
            Total Employees
          </div>
          <div className="prospects-sidebar__categories-info-item">
            {renderPermittedField(settings.pending ? <Skeleton height={14} /> : (publisher.publisher_size || 'Not Identified'))}
          </div>
          <div className="prospects-sidebar__categories-subhead">
            Links
          </div>
          {renderPermittedField(settings.pending ? <Skeleton height={32} /> : (
            <div className="prospects-sidebar__categories-info-item prospects-sidebar__categories-info-item-links">
              {publisherLinks.reduce((results, link) => [...results, (
                <Button
                  key={link.field}
                  shape="square"
                  variant="secondary"
                  href={publisher[link.field]}
                  target="_blank"
                  disabled={!publisher[link.field]}
                >
                  <span className={link.icon} />
                </Button>
              )], [])}
            </div>
          ))}
        </div>
      </div>

      <div className="prospects-sidebar__categories-items">
        <div className="prospects-sidebar__categories-head h4">
          Top Categories
        </div>
        <div className="prospects-sidebar__categories-table">
          {(settings.pending || showCategories) ? (
            <Fragment>
              <div className="prospects-sidebar__categories-table-head">
                <div className="prospects-sidebar__categories-table-head-item">
                  Category
                </div>
                <div className="prospects-sidebar__categories-table-head-item">
                  # of Apps
                </div>
              </div>
              <div className="prospects-sidebar__categories-table-body">
                {settings.pending
                  ? times(4).map(n => <Skeleton key={n} height={24} />)
                  : publisher.categories.map(category => (
                    <div key={category.name} className="prospects-sidebar__categories-table-body-item">
                      <div className="prospects-sidebar__categories-table-body-item-name text-truncate">
                        {category.name}
                      </div>
                      <div className="prospects-sidebar__categories-table-body-item-numb">
                        {category.apps_per_category}/{publisher.total_apps}
                      </div>
                    </div>
                  ))}
              </div>
              <TotalCount publisher={publisher} totalCount={publisher.total_categories_number} />
            </Fragment>
          ) : <EmptyBox text="No categories detected" />}
        </div>
      </div>
    </div>
  );
};

PubCategories.propTypes = {
  publisher: T.object.isRequired,
  settings: T.object.isRequired,
};

export default PubCategories;
